import $ from 'jquery'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import FilterBadges from 'scoreboard/components/filter-badges'
import assignLinkGroups from 'scoreboard/components/assign-link-groups'
import groupType from 'scoreboard/admin/principals/groups/group-type'

function formatAndGroupByOr(filters, meta) {
	return  _(filters)
		.flatMap((filterValue, filterKey) => {
			return _.map(filterValue, (value, index) => {
				return {
					filterKey: filterKey,
					filterValue: value,
					filterIndex: index,
					label: i18n.get(meta[filterKey].nameCode),
					filterText: meta.stringify(value, filterKey),
					valid: _.isEmpty(value.invalidValues) && value.valid !== false,
					linkGroup: value.linkGroup
				}
			})
		})
		.groupBy('linkGroup')
		.value()
}

function groupTypeLabels(filters) {
	_.each(filters, f => {
		_.each(f.values, v => {
			let typeLabel = groupType.label(v.groupType)
			if (_.has(v, 'groupType') && !_.isNil(typeLabel)) {
				let groupTypeLabel = `<span class="post-label"> (${typeLabel})</span>`
				// don't keep appending if it's already there (adding ors in dialog)
				if (!_.endsWith(v.label, groupTypeLabel)) {
					v.label = v.label
					v.postLabel = groupTypeLabel
				}
			}
		})
	})
}

const ReportFilterBadges = FilterBadges.extend({

	/**
	 * A "generic" Report Filter badge.  Callers can listen for 'click' and 'delete' events on the badges
	 * themselves.  If the badge is read only, no 'delete' events will be triggered.
	 *
	 * Does not handle dataset-filters, those are handles specifically by dataset-filters.js
	 * see dataset-report-form
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 * @param {Object} options.filters the report filter object containing the filters being displayed
	 * @param {boolean} [options.selected=null] the filter whose badge that should be initially selected
	 * @param {boolean} [options.defaultSelect=true] if true and only one badge is available it should be initially
	 * selected. This is ignored if options.selected is defined
	 * @param {Object} options.meta={report meta} meta data to render the types of filters available
	 */
	initialize: function(options = {}) {
		FilterBadges.prototype.initialize.apply(this, arguments)
		if (!this.options.meta) {
			throw new Error('Must define the filter meta data for filter badges')
		}
		this.noneMessage =  i18n.get('common.thereAreNo', 'report.wizard.filters')

		this.filters = this.options.filters

		//ensure linkGroups assigned
		assignLinkGroups(_.flatMap(this.filters))

		// #11891 display group type labels for owners and updaters
		groupTypeLabels(_.flatMap(this.filters))

		this.options.filtersByLinkGroup = () => {
			//ignore projectsFilter it's not editable on the client
			let editableFilters = _.omit(this.filters, 'projectIds')
			this.filtersByGrouping = formatAndGroupByOr(editableFilters,
				this.options.meta)
			return this.filtersByGrouping
		}
	},

	render: function() {
		FilterBadges.prototype.render.apply(this, arguments)
		if (this.options.selected) {
			if (!_.isNil(this.options.selected.linkGroup)) {
				this.$(`div[data-link-group=${this.options.selected.linkGroup}].badge`).addClass('is-selected')
			}
		} else if (this.$('.badge').length == 1 && this.options.defaultSelect) {
			// #13991 if there's only one filter, select it by default
			this.$('.badge').addClass('is-selected')
		}
		return this
	},

	clickFilter: function(e) {
		this.$('.badge').removeClass('is-selected')
		let filter = $(e.currentTarget).closest('.filter')
		filter.closest('.badge').addClass('is-selected')
		FilterBadges.prototype.clickFilter.apply(this, arguments)
	},

	/**
	 * Returns the filter a user clicked on
	 */
	getFilterCtxForEvent: function(e) {
		let filter = $(e.currentTarget).closest('.filter')
		let badge = filter.closest('.badge')
		return this.filtersByGrouping[badge.data('link-group')][filter.data('index')]
	},

	/**
	 * Returns the filter(s) selected or a empty array if nothing selected
	 */
	selected: function() {
		let badge = this.$('.badge.is-selected')
		if (badge.length == 0) {
			return []
		}
		return this.filtersByGrouping[badge.data('link-group')]
	}

})

export default ReportFilterBadges

ReportFilterBadges.__filename__ = 'reports/common/filter/report-filter-badges.js'
